module.exports = __webpack_public_path__ + "img/qingyang4.ad2d6638.png";